import React from 'react'
import {  Splitter} from 'antd';


const Apvoid=()=> {
    
    return (
        <>

<Splitter style={{ height: '90%', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
    <Splitter.Panel defaultSize="20%" min="10%" max="25%">
    
    </Splitter.Panel>
    <Splitter.Panel>
     
    </Splitter.Panel>
  </Splitter>

        </>
    )
}

export default Apvoid